import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Col,
  Form,
  FormGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  Row,
} from 'shards-react';

import DateInput from '../../../form/DateInput';
import SelectInput from '../../../form/SelectInput';
import { STATE_DATA } from '../../../form/states.data';
import TelInput from '../../../form/TelInput';
import TextInput from '../../../form/TextInput';
import { updateProfile } from '../../../../pages/Dashboard/UpdateProfile/profileActions';
import { closeModal } from '../../modalActions';
import { format } from 'date-fns';

import * as validation from '../../../util/validation';

const validate = combineValidators({
  userFullName: isRequired('full name'),
});

const mapState = (state) => ({
  initialValues: state.firebase.profile,
  auth: state.firebase.auth,
  statesArray: STATE_DATA,

  currentYear: new Date().getFullYear(),
  user: state.firebase.profile,
});

const actions = {
  updateProfile,
  closeModal,
};
const handleValidation = (e) => {
  console.log(e);
};

class UpdateProfileModal extends Component {
  render() {
    const { statesArray } = this.props;
    const {
      handleSubmit,
      error,
      updateProfile,
      pristine,
      submitting,
      currentYear,
      user,
      closeModal,
      invalid,
    } = this.props;

    return (
      <Modal
        open={true}
        toggle={closeModal}
        backdrop='static'
        backdropClassName='backdrop'
        modalClassName='modal'
        fade={true}
        centered={true}
        role='dialog'
      >
        <ModalHeader>Add Complaint</ModalHeader>

        <Form onSubmit={handleSubmit(updateProfile)}>
          <ListGroupItem>
            Update Profile
            <Row>
              <Col md='4' sm='12' className='form-group'>
                <label htmlFor='userFullName'>Full Name</label>
                <Field
                  component={TextInput}
                  name='userFullName'
                  type='text'
                  placeholder={'Fullname'}
                  validate={validation.fullName}
                />
              </Col>
              <Col md='4' sm='12' className='form-group'>
                <label htmlFor='userCitizenship'>Citizenship</label>
                <Field
                  component={SelectInput}
                  name='userCitizenship'
                  options={[
                    { label: '', value: '' },
                    { label: 'Malaysian', value: 'malaysian' },
                    { label: 'Foreigner', value: 'foreigner' },
                  ]}
                  type='text'
                  placeholder={''}
                />
              </Col>
              <Col md='4' className='form-group'>
                <label htmlFor='userNationalId'>NRIC or Passport Number</label>
                <Field
                  name='userNationalId'
                  type='text'
                  component={TextInput}
                  placeholder='Enter a valid National ID'
                />
              </Col>
            </Row>
            <Row form>
              <Col md='4' sm='12' lg='12' className='form-group'>
                <label htmlFor='userDOB'>
                  Date of Birth : {format(user.userDOB.toDate(), 'EEEE do LLL')}
                </label>
                <Field
                  name='userDOB'
                  type='date'
                  component={DateInput}
                  placeholder='Enter you date of birth'
                />
              </Col>
              <Col md='4' sm='12' lg='12' className='form-group'>
                <label htmlFor='userGender'>Gender</label>
                <Field
                  component={SelectInput}
                  name='userGender'
                  options={[
                    { label: '', value: '' },
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ]}
                  type='text'
                  placeholder={''}
                />
              </Col>
            </Row>
            <Row>
              <Col md='6' className='form-group'>
                <label htmlFor='userRace'>Race</label>
                <Field
                  name='userRace'
                  type='select'
                  component={SelectInput}
                  placeholder=''
                />
              </Col>
              <Col>
                Age:
                {user.userDOB
                  ? currentYear - new Date(user.userDOB.toDate()).getFullYear()
                  : ''}
              </Col>
            </Row>
          </ListGroupItem>
          <ListGroupItem>
            <strong>Contact Details </strong>
            <Row form>
              <Col className='form-group'>
                <FormGroup>
                  <label htmlFor='userAddress1'>Address1</label>
                  <Field
                    component={TextInput}
                    type='text'
                    name='userAddress1'
                    placeholder={''}
                  />
                </FormGroup>
              </Col>
              <Col className='form-group'>
                <FormGroup>
                  <label htmlFor='userAddress2'>Address2</label>
                  <Field
                    component={TextInput}
                    type='text'
                    name='userAddress2'
                    placeholder={''}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md='4' className='form-group'>
                <label htmlFor='userAddressTown'>Town</label>
                <Field
                  component={TextInput}
                  name='userAddressTown'
                  type='text'
                  placeholder={''}
                />
              </Col>
              <Col md='6' className='form-group'>
                <label htmlFor='userAddressState'>State</label>
                <Field
                  component={SelectInput}
                  name='userAddressState'
                  options={statesArray}
                  type='text'
                  placeholder={''}
                />
              </Col>
              <Col md='2'>
                <label htmlFor='userAddressPostCode'>Post Code</label>
                <Field
                  name='userAddressPostCode'
                  type='text'
                  component={TextInput}
                  placeholder={''}
                />
              </Col>
            </Row>
            <Row>
              <Col className='form-group'>
                <label htmlFor='userTel'>Tel</label>
                <Field
                  name='userTel'
                  type='tel'
                  component={TelInput}
                  placeholder='Enter a valid phone number'
                />
              </Col>
              <Col className='form-group'>
                <label htmlFor='userTel'>Mobile</label>
                <Field
                  name='userContactAlt'
                  type='tel'
                  component={TelInput}
                  placeholder='Enter a valid phone number'
                />
              </Col>
              <Col className='form-group'>
                <label htmlFor='userTel'>Office</label>
                <Field
                  name='userOfficeContact'
                  type='tel'
                  component={TelInput}
                  placeholder='Enter a valid phone number'
                />
              </Col>
            </Row>
          </ListGroupItem>
          <ListGroupItem>
            <strong> Census Data </strong>
            <p>Your data will be kept anonymous in the analytics data.</p>
            <Row>
              <Col md='6' className='form-group'>
                <label htmlFor='userIncomeGroup'>Income Group</label>
                <Field
                  name='userIncomeGroup'
                  type='select'
                  component={SelectInput}
                  options={[
                    { label: '', value: '' },
                    { label: 'RM 0 - 3,000', value: '0-3000' },
                    { label: 'RM 3,001 - 5,000', value: '3001-5000' },
                    { label: 'RM 5,001 - 8,000', value: '5001-8000' },
                    { label: 'RM 8,001 and above', value: '8001 & above' },
                  ]}
                  placeholder='Enter a valid phone number'
                />
              </Col>
              <Col md='6' className='form-group'>
                <label htmlFor='userEducation'>Education Level</label>
                <Field
                  name='userEducation'
                  type='select'
                  component={SelectInput}
                  options={[
                    { label: '', value: '' },
                    {
                      label: 'Primary Education / Sekolah Rendah',
                      value: 'primary_education',
                    },
                    {
                      label:
                        'Lower Secondary Education / Sekolah Menengah Rendah',
                      value: 'lower_secondary_education',
                    },
                    {
                      label:
                        'Upper Secondary Education / Sekolah Menengah Atas',
                      value: 'upper_secondary_education',
                    },
                    {
                      label: 'Certificate / Sijil Kemahiran',
                      value: 'certificate',
                    },
                    { label: 'Diploma / Diploma', value: 'diploma' },
                    { label: 'Degree / Ijazah', value: 'degree' },
                    { label: 'Masters / Ijazah Lanjutan', value: 'masters' },
                    {
                      label: 'Doctorate / Ijazah Kedoktoran',
                      value: 'doctorate',
                    },
                  ]}
                  placeholder='Enter a valid phone number'
                />
              </Col>
            </Row>
            <Row>
              <Col md='6' className='form-group'>
                <label htmlFor='userOccupation'>Occupation</label>
                <Field
                  name='userOccupation'
                  type='select'
                  component={SelectInput}
                  options={[
                    { label: '', value: '' },
                    {
                      label: 'Civil Servant / Kakitangan Kerajaan',
                      value: 'civil_servant',
                    },
                    {
                      label: 'Professional / Professional',
                      value: 'professional',
                    },
                    { label: 'Technical / Teknikal', value: 'technical' },
                    { label: 'Businessman / Peniaga', value: 'businessman' },
                    { label: 'Student / Pelajar', value: 'student' },
                    {
                      label: 'Own Business / Bekerja Sendiri',
                      value: 'own_business',
                    },
                    {
                      label: 'Unemployed / Tiada Bekerja',
                      value: 'unemployed',
                    },
                    { label: 'Others / Lain-Lain', value: 'others' },
                  ]}
                />
              </Col>
            </Row>

            <Button
              theme='success'
              type='submit'
              disabled={pristine || submitting || invalid}
            >
              Update Profile
            </Button>
            {error && <label className='error-label'>{error}</label>}
          </ListGroupItem>
        </Form>
      </Modal>
    );
  }
}

export default connect(
  mapState,
  actions
)(reduxForm({ form: 'profileForm', validate })(UpdateProfileModal));
